import {
    INotificationChannel,
    INotificationChannelCreateDto,
    INotificationChannelUpdateDto,
    INotificationChannelUseCase,
} from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class NotificationChannelUseCase implements INotificationChannelUseCase {
    public async select(companyId: string): Promise<INotificationChannel[]> {
        try {
            const response = await Api.get<INotificationChannel[]>(`/companies/${companyId}/notifications/channels`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string, channelId: string): Promise<INotificationChannel> {
        try {
            const response = await Api.get<INotificationChannel>(
                `/companies/${companyId}/notifications/channels/${channelId}`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async create(companyId: string, dto: INotificationChannelCreateDto): Promise<INotificationChannel> {
        try {
            const response = await Api.post<INotificationChannel>(
                `/companies/${companyId}/notifications/channels`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(
        companyId: string,
        channelId: string,
        dto: INotificationChannelUpdateDto,
    ): Promise<INotificationChannel> {
        try {
            const response = await Api.put<INotificationChannel>(
                `/companies/${companyId}/notifications/channels/${channelId}`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async enable(companyId: string, channelId: string): Promise<INotificationChannel> {
        try {
            const response = await Api.post<INotificationChannel>(
                `/companies/${companyId}/notifications/channels/${channelId}/enable`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async disable(companyId: string, channelId: string): Promise<INotificationChannel> {
        try {
            const response = await Api.post<INotificationChannel>(
                `/companies/${companyId}/notifications/channels/${channelId}/disable`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async delete(companyId: string, channelId: string): Promise<void> {
        try {
            await Api.delete<void>(`/companies/${companyId}/notifications/channels/${channelId}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
